import { RESTORE_FAILURE, RESTORE_REQUEST, RESTORE_SUCCESS } from '../../../../constants/ActionNameConstants';

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const restoreReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESTORE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case RESTORE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case RESTORE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default restoreReducer;
